import * as React from "react";

import { FileUploadInput } from "kw/util/Question/inputs/FileUploadInput";
import { FlowLayout } from "kw/components/FlowLayout";
import { QuestionFlowTypeKey } from "kw/components/QuestionFlow/QuestionFlowComponent";
import { SidePadder } from "kanopi-components/Layout";
import { quoteFlowFields } from "kw/api/fragments";
import { useGlobal } from "kanopi-components/useGlobal";
import { useNavigate } from "@reach/router";
import { useStartQuestionFlow } from "kw/hooks/useStartQuestionFlow";

export const AutoQuote = () => {
  const [uploadingText, setUploadingText] = React.useState("Uploading...");
  const [file, setFile] = React.useState(null);
  const [data] = useGlobal("quoting");

  let enabledProducts = data?.enabledProducts;
  if (!enabledProducts) {
    enabledProducts = [data.riskProfile.enabledProducts[0].key];
  }
  const startQuoteQuery = (autoQuote = false, fileLink) => ({
    startQuote: [
      {
        input: {
          questionSetKey: undefined,
          enabledProducts,
          create: true,
          restart: false,
          autoQuote,
          fileLink,
        },
      },
      { ...quoteFlowFields },
    ],
  });
  const { startQuestionFlow } = useStartQuestionFlow({
    mutationQuery: startQuoteQuery(),
    globalDataKey: QuestionFlowTypeKey.quote,
    questionFlowResponseKey: "startQuote",
  });
  const [loading, setLoading] = React.useState(false);
  const navigate = useNavigate();
  const onFileUpload = (fileUploadResponse) => {
    setLoading(true);
    setTimeout(() => {
      setUploadingText("Processing Quote slip...");
    }, 3000);
    setTimeout(() => {
      setUploadingText("Preparing the quote...");
    }, 8000);
    setTimeout(() => {
      startQuestionFlow(startQuoteQuery(true, fileUploadResponse.link), () => {
        navigate(`getquote?product=${enabledProducts[0]}`);
      });
    }, 10000);
  };

  return (
    <SidePadder padding="flow">
      <FlowLayout
        steps={[
          {
            label: "Your details",
            active: true,
          },
          { label: "Your quote" },
          { label: "Review and buy" },
        ]}
        history={[]}
      >
        <FileUploadInput
          onChange={onFileUpload}
          uploading={loading}
          uploadingText={uploadingText}
          file={file}
        />
      </FlowLayout>
    </SidePadder>
  );
};
